import { Component, OnInit } from '@angular/core';
import { DemographicsR7Component } from '../demographics-r7/demographics-r7.component';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import {
	R11_CHARTS_TOOLTIPS,
	R1102_CHARTS_TOOLTIPS,
	EVENT_EMITTERS,
	R9_CHARTS_TOOLTIPS
} from '../../../analytics/constants/analytics.constants';
import * as _ from 'underscore';
import * as Highcharts from 'highcharts';

@Component({
	selector: 'app-demographics-r11',
	templateUrl: './demographics-r11.component.html',
	styleUrls: ['./demographics-r11.component.css']
})
export class DemographicsR11Component extends DemographicsR7Component implements OnInit {
	public isR1102Config: boolean = false;
	public isR9: boolean;
	public isR8: boolean;
	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected colorUtilityService: ColorUtilityService
	) {
		super(analyticsService, analyticsDataModel, colorUtilityService);
	}

	ngOnInit() {
		this.isR9 = this.analyticsDataModel.config.version === 'R9' ? true : false;
		this.isR8 = this.analyticsDataModel.config.version === 'R8' ? true : false;
		super.ngOnInit();
		this.isR1102Config = this.analyticsDataModel.config.directoryName.toLowerCase() === 'default-r1102' ? true : false;
	}

	ngAfterContentChecked() {
		super.ngAfterContentChecked();
	}

	requestData() {
		this.showLoad = true;
		this.widgetDataSubscription = this.analyticsService
			.processCustomServiceRequest(this.key)
			.subscribe((response: any) => {
				this.showLoad = false;
				this.currentLegendItem = 'impressions';
				if (response.success && response.data.length > 0) {
					this.hasData = true;
					this.responseData = response.data;
					this.processResponseData(response.data);
				} else {
					this.hasData = false;
				}
			});
	}

	drawGraph() {
		const self = this;
		let CHARTS_TOOLTIPS = {};
		if (this.isR1102Config) {
			CHARTS_TOOLTIPS = R1102_CHARTS_TOOLTIPS;
		} else if (this.isR9) {
			CHARTS_TOOLTIPS = R9_CHARTS_TOOLTIPS;
		} else {
			CHARTS_TOOLTIPS = R11_CHARTS_TOOLTIPS;
		}
		let ageGroupData = Object.keys(_.groupBy(this.responseData, 'age_group'));
		ageGroupData[0] = this.isR8 ? '13-17' : 'Under 18';
		Highcharts.chart('chartElement', {
			chart: {
				type: 'column',
				height: !UtilityService.isUndefinedOrNull(this.chartconfiguration?.height)
					? this.chartconfiguration.height
					: 270,
				backgroundColor: '#f6f6f6'
			},
			title: {
				text: ''
			},
			subtitle: {
				text: ''
			},
			legend: {
				enabled: true,
				align: 'center',
				verticalAlign: 'bottom',
				symbolHeight: 10,
				symbolWidth: 10,
				symbolRadius: 10,
				useHTML: true,
				itemMarginTop: 16,
				itemMarginBottom: 0,
				itemDistance: 30,
				itemStyle: {
					fontFamily: 'OpenSans',
					color: '#2e2e2e',
					fontWeight: 'normal',
					fontSize: '12px',
					letterSpacing: -0.3
				}
			},
			xAxis: {
				categories: ageGroupData,
				lineColor: '#2e2e2e',
				lineWidth: this.isR8 ? 1 : 2,
				tickLength: 0,
				offset: this.isR8 ? 0 : 50,
				labels: {
					y: this.isR8 ? undefined : -23,
					style: {
						fontFamily: 'OpenSans',
						fontSize: '12px',
						color: '#2e2e2e',
						fontWeight: 'normal'
					}
				}
			},
			yAxis: {
				visible: this.isR8 ? true : false,
				gridLineWidth: 0,
				min: 0,
				title: {
					text: null
				},
				labels: {
					enabled: this.isR8 ? true : false
				}
			},
			tooltip: Object.assign({}, CHARTS_TOOLTIPS, {
				useHTML: true,
				outside: true,
				formatter: function () {
					return (
						'<div class="toolOut demographicsTooltip" style="width: 136px;height: 85px;padding: 12px;display:grid;grid-template-rows: 10px 12px 12px;grid-row-gap: 11px"><div><div style="width:fit-content;margin:auto;"><div class="demographicsTooltipColor" style="width:10px;height:10px;background-color:' +
						this.series.color +
						';border-radius:50% !important; margin-top: 5px; margin-right:5px;float:left;"></div><div class="demographicsTooltipColorR1102" style="display:none;width:10px;height:10px;background-color:' +
						this.series.color +
						'; margin-top: 5px; margin-right:5px;float:left;"></div><div style="font-family: `OpenSans`;font-size: 10px; color: #2e2e2e;float:left; margin-top: -3px">' +
						this.series.name.toLocaleString() +
						'</div></div></div><div style="display:grid;grid-template-columns: 59px auto;font-family:`OpenSans`;font-size:10px;font-weight:`normal`;color:#2e2e2e;text-align:left;margin-top: 2px;"><div>' +
						self.totalDemogImpClicks[0]['legendName'] +
						'</div><div class="tooltipValue" style="font-size:10px;font-weight:300;text-align: right;">' +
						this.y.toLocaleString() +
						'</div></div><div style="display:grid;grid-template-columns: 59px auto;font-family:`OpenSans`;font-size:10px;font-weight:`normal`;color:#2e2e2e;text-align:left;margin-top: 2px;"><div>% of Age Group</div><div class="tooltipValue" style="font-size:10px;font-weight: 300;text-align: right;">' +
						(
							(this.y * 100) /
							self.totalDemogImpClicks[self.totalDemogImpClicks.findIndex((x) => x['name'] === this.series['name'])][
								'value'
							]
						).toFixed(2) +
						'%' +
						'</div></div></div>'
					);
				},
				borderRadius: this.isR8 ? 20 : 0,
				borderWidth: this.isR8 ? 1 : 0,
				borderColor: this.isR8 ? '#4a4a4a' : 'transparent'
			}),
			plotOptions: {
				column: {
					pointWidth: !UtilityService.isUndefinedOrNull(this.chartconfiguration?.graphConfig?.pointWidth)
						? this.chartconfiguration.graphConfig.pointWidth
						: 7,
					groupPadding: this.isR8 ? 0.25 : 0.1,
					borderWidth: 0,
					borderRadius: !UtilityService.isUndefinedOrNull(this.chartconfiguration?.graphConfig?.borderRadius)
						? this.chartconfiguration.graphConfig.borderRadius
						: 5
				},
				series: {
					states: {
						inactive: {
							opacity: 1
						}
					}
				}
			},
			series: this.updateBorders(this.seriesObjR11)
		});
	}
	updateBorders(series: any): any {
		if (this.isR9 || this.isR8) {
			series.forEach((element) => {
				element['borderRadiusTopLeft'] = '50%';
				element['borderRadiusTopRight'] = '50%';
			});
		}
		return series;
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}
}
